import { deleteRequest } from '..';

const deleteUserGroup = (userGroupId: string) => deleteRequest(
  'users/v2/user-groups',
  { userGroupId },
);

export default deleteUserGroup;
